import { delay } from '../utils/helpers.js';

export class FeedbackService {
	constructor(baseAPI) {
		this.api = baseAPI;
	}

	async submitFeedback(feedbackData) {
		await this.api._ensureSession();

		if (this.api.mock) {
			await delay(500);
			return {
				success: true,
				data: {
					id: 'mock_post_' + Date.now(),
					title: feedbackData.title,
					content: feedbackData.content,
				},
				message: 'Feedback submitted successfully!',
			};
		}

		const contact = this.api.getContactIdentity();
		const metadata =
			(typeof this.api.getMetadata === 'function'
				? this.api.getMetadata()
				: this.api.metadata) || null;
		const boardSlug =
			feedbackData.board_id || feedbackData.board || feedbackData.boardName;

		const resolvedContactId = contact?.contactId || metadata?.user_id || null;
		const resolvedContactEmail =
			contact?.contactEmail || metadata?.email || null;
		const resolvedContactName = contact?.contactName || metadata?.name || null;
		const isIdentified = !!(resolvedContactId || resolvedContactEmail);

		// Identified contact → authenticated endpoint with contact linkage.
		// Anonymous → public endpoint (matches end-user board's anonymous flow).
		// /widget/feedback returns 500 for unauthenticated submissions.
		if (isIdentified) {
			const payload = {
				board: boardSlug,
				title: feedbackData.title,
				content: feedbackData.content,
				attachments: feedbackData.attachments || [],
			};
			if (resolvedContactId) payload.contact_id = resolvedContactId;
			if (resolvedContactEmail) payload.contact_email = resolvedContactEmail;
			if (resolvedContactName) payload.contact_name = resolvedContactName;

			return this.api._handleAuthRetry(async () => {
				return this.api._makeRequest('/widget/feedback', {
					method: 'POST',
					body: JSON.stringify(payload),
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${this.api.sessionToken}`,
					},
				});
			});
		}

		const anonPayload = {
			board_slug: boardSlug,
			title: feedbackData.title,
			content: feedbackData.content,
			attachments: feedbackData.attachments || [],
			website: '',
		};
		if (feedbackData.email) {
			anonPayload.email = feedbackData.email;
		}

		return this.api._makeRequest('/public/posts', {
			method: 'POST',
			body: JSON.stringify(anonPayload),
			headers: {
				'Content-Type': 'application/json',
			},
		});
	}
}
